import { FC } from 'react'
import Link from 'next/link'
import styles from './index.module.scss'
import { IJobBase } from '../../../types'
import { getJobThumbnail, sanitizeUrl } from '../../../utils'
import { JobCardContent } from '../JobCardContent'

type Props = {
  job: IJobBase
}

export const CompanyProfileJobItem: FC<Props> = ({ job }) => {
  const linkToJobDetails = sanitizeUrl(`/jobs/${job?.slug}`)

  return (
    <Link href={linkToJobDetails}>
      <a className={styles.container}>
        <div className={styles.thumbnail}>
          <img src={getJobThumbnail(job)} alt={job?.title} className='img-fluid' />
        </div>
        <div className={styles.content}>
          <JobCardContent job={job} />
        </div>
      </a>
    </Link>
  )
}
